import React from 'react';
import { Box, Container, Typography, Link, useTheme, Divider, Grid, Stack } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { Copyright, Email, Phone } from '@mui/icons-material';
import { tenantConfig } from '../config/tenantConfig'; // 🚨 Import your config

const Footer = () => {
    const theme = useTheme();

    const isDarkMode = theme.palette.mode === 'dark';
    const bgColor = isDarkMode ? theme.palette.background.paper : '#e0e0e0';
    const textColor = isDarkMode ? theme.palette.text.secondary : theme.palette.text.primary;
    const dividerColor = isDarkMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)';

    return (
        <Box component="footer" sx={{ py: 4, mt: 'auto', width: '100%', bgcolor: bgColor, borderTop: `1px solid ${dividerColor}`, color: textColor }}>
            <Container maxWidth="xl">
                <Grid container spacing={4} justifyContent="space-between">

                    {/* --- Section 1: Brand & Copyright --- */}
                    <Grid item xs={12} sm={6} md={4}>
                        <Typography variant="h6" color="primary" gutterBottom fontWeight="bold">
                            {tenantConfig.name} {/* 🚨 Dynamic Tenant Name */}
                        </Typography>
                        <Typography variant="body2" sx={{ mb: 1 }}>
                            Empowering future leaders through education funding management.
                        </Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Copyright fontSize="small" sx={{ mr: 0.5 }} />
                            <Typography variant="caption">
                                {new Date().getFullYear()} {tenantConfig.name}. | Powered by BrightSparc. | All rights reserved.
                            </Typography>
                        </Box>
                    </Grid>

                    {/* --- Section 2: Quick Links (Always BrightSparc Legal) --- */}
                    <Grid item xs={6} sm={3} md={2}>
                        <Typography variant="subtitle1" gutterBottom fontWeight="bold">Quick Links</Typography>
                        <Stack direction="column" spacing={1}>
                            <Link component={RouterLink} to="/privacy-policy" color="inherit" underline="hover" variant="body2">Privacy Policy</Link>
                            <Link component={RouterLink} to="/terms-of-service" color="inherit" underline="hover" variant="body2">Terms of Service</Link>
                            {/* 🚨 ADDED BILLING POLICY HERE */}
                            <Link component={RouterLink} to="/billing-policy" color="inherit" underline="hover" variant="body2">Billing & Refund Policy</Link>
                            <Link component={RouterLink} to="/about-us" color="inherit" underline="hover" variant="body2">About Us</Link>
                        </Stack>
                    </Grid>

                    {/* --- Section 3: Support --- */}
                    <Grid item xs={6} sm={3} md={2}>
                        <Typography variant="subtitle1" gutterBottom fontWeight="bold">Support</Typography>
                        <Stack direction="column" spacing={1}>
                            <Link component={RouterLink} to="/faq" color="inherit" underline="hover" variant="body2">FAQ</Link>
                            <Link component={RouterLink} to="/contact" color="inherit" underline="hover" variant="body2">Contact Us</Link>
                            <Link component={RouterLink} to="/sitemap" color="inherit" underline="hover" variant="body2">Sitemap</Link>
                        </Stack>
                    </Grid>

                    {/* --- Section 4: Dynamic Contact Info --- */}
                    <Grid item xs={12} md={4}>
                         <Typography variant="subtitle1" gutterBottom fontWeight="bold">Get In Touch</Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <Email fontSize="small" sx={{ mr: 1, color: theme.palette.primary.main }} />
                            <Typography variant="body2">{tenantConfig.contactEmail || 'support@brightsparc.co.za'}</Typography>
                        </Box>
                        {tenantConfig.contactPhone && (
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <Phone fontSize="small" sx={{ mr: 1, color: theme.palette.primary.main }} />
                                <Typography variant="body2">{tenantConfig.contactPhone}</Typography>
                            </Box>
                        )}
                    </Grid>
                </Grid>
                <Divider sx={{ mt: 4, mb: 2, bgcolor: dividerColor }} />
                <Typography variant="caption" align="center" display="block" color={textColor} sx={{ opacity: 0.7 }}>
                    Disclaimer: This is a platform for educational funding management.
                </Typography>
            </Container>
        </Box>
    );
};

export default Footer;